"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareUtils = exports.EShareNetworkName = void 0;
const assert_1 = __importDefault(require("assert"));
function objectToGetParams(object) {
    const params = Object.entries(object)
        .filter(([, value]) => value != null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    return params.length > 0 ? `?${params.join("&")}` : "";
}
function twitterLink(url, { title, via, hashtags = [] }) {
    (0, assert_1.default)(url, "twitter.url");
    (0, assert_1.default)(Array.isArray(hashtags), "twitter.hashtags is not an array");
    return ("https://twitter.com/share" +
        objectToGetParams({
            url,
            text: title,
            via,
            hashtags: hashtags.join(","),
        }));
}
function facebookLink(url, { quote, hashtag }) {
    (0, assert_1.default)(url, "facebook.url");
    return ("https://www.facebook.com/sharer/sharer.php" +
        objectToGetParams({
            u: url,
            quote,
            hashtag,
        }));
}
const getBoxPositionOnWindowCenter = (width, height) => ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
});
const getBoxPositionOnScreenCenter = (width, height) => ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
});
function windowOpen(url, { height, width, ...configRest }, onClose) {
    const config = {
        height,
        width,
        location: "no",
        toolbar: "no",
        status: "no",
        directories: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "no",
        centerscreen: "yes",
        chrome: "yes",
        ...configRest,
    };
    const shareDialog = window.open(url, "", Object.keys(config)
        .map((key) => `${key}=${config[key]}`)
        .join(", "));
    if (onClose) {
        const interval = window.setInterval(() => {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var EShareNetworkName;
(function (EShareNetworkName) {
    EShareNetworkName["TWITTER"] = "twitter";
    EShareNetworkName["FACEBOOK"] = "facebook";
})(EShareNetworkName || (exports.EShareNetworkName = EShareNetworkName = {}));
function clickFacebookShare(shareUrl, options = {}) {
    clickShare(shareUrl, EShareNetworkName.FACEBOOK, options);
}
function clickTwitterShare(shareUrl, options = {}) {
    clickShare(shareUrl, EShareNetworkName.TWITTER, options);
}
function clickShare(shareUrl, network, options) {
    let link;
    switch (network) {
        case EShareNetworkName.FACEBOOK:
            link = facebookLink(shareUrl, (options ?? {}));
            break;
        case EShareNetworkName.TWITTER:
            link = twitterLink(shareUrl, (options ?? {}));
            break;
        default:
            throw new Error(`clickShare(): Need to set a share network to create a share link`);
    }
    const { onShareWindowClose, windowHeight = 400, windowPosition = "windowCenter", windowWidth = 550, } = options ?? {};
    const windowConfig = {
        height: windowHeight,
        width: windowWidth,
        ...(windowPosition === "windowCenter"
            ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
            : getBoxPositionOnScreenCenter(windowWidth, windowHeight)),
    };
    windowOpen(link, windowConfig, onShareWindowClose);
}
exports.ShareUtils = {
    clickFacebookShare,
    clickTwitterShare,
};
